<template>
    <!-- start 练习成绩弹窗 -->
    <div></div>
    <!-- end 练习成绩弹窗 -->
</template>

<script>
export default {
  name: "ExercisePopup",
  data(){
    return {
      
    }
  },
}
</script>

<style scoped lang="scss">

</style>